import { ItemCustos } from '../../../item/custos';
import { AliquotasDRP } from '../aliquotas';
import { DRP } from '../drp';
import { IGrupoRentabilidadeRef } from '../../../../domains/core/settings/grupos-rentabilidade/interfaces/grupo-rentabilidade.interface';
import { IGruposRentabilidadeResponse } from '../../../../domains/core/settings/grupos-rentabilidade/interfaces/grupos-rentabilidade-response.interface';
import { getGrupoRentabilidadeByMargem } from '../../../../domains/shared/utils/grupos-rentabilidade/grupo-rentabilidade.util';

export class PedidoItemDRP extends DRP {
    aliquotas: AliquotasDRP;
    itemCustos: ItemCustos;
		/** Grupo de rentabilidade padrão do item (cadastrado no item) */
		grupoRentabilidadePadrao: IGrupoRentabilidadeRef;
		gruposRentabilidade: IGruposRentabilidadeResponse[] | null = null;


    /* Obtem o percentual da alíquota do ICMS */
    getPercAliquotaIcms(): number {
		// Alíquota fixa no estado do item
		if (this.itemCustos && (this.itemCustos.percAliquotaIcms != null && this.itemCustos.percAliquotaIcms !== undefined)) {
			return this.itemCustos.percAliquotaIcms;
		}
		// Alíquota atual
        return this.aliquotas?.percAliquotaIcms ?? 0;
    }

    /* Obtem o percentual da alíquota do PIS */
    getPercAliquotaPis(): number {
		// Override do item (inclusive 0) prevalece sobre a empresa
		if (this.itemCustos && (this.itemCustos.percDvvAliquotaPis != null && this.itemCustos.percDvvAliquotaPis !== undefined)) {
			return this.itemCustos.percDvvAliquotaPis;
		}
    	return this.aliquotas?.percAliquotaPis ?? 0;
    }

    /* Obtem o percentual da alíquota do COFINS */
    getPercAliquotaCofins(): number {
		// Override do item (inclusive 0) prevalece sobre a empresa
		if (this.itemCustos && (this.itemCustos.percDvvAliquotaCofins != null && this.itemCustos.percDvvAliquotaCofins !== undefined)) {
			return this.itemCustos.percDvvAliquotaCofins;
		}
    	return this.aliquotas?.percAliquotaCofins ?? 0;
    }

    /* Obtem o percentual do frete */
    getPercDvvFrete(): number {
		// Override do item (inclusive 0) prevalece sobre a empresa
		if (this.itemCustos && (this.itemCustos.percDvvFrete != null && this.itemCustos.percDvvFrete !== undefined)) {
			return this.itemCustos.percDvvFrete;
		}
    	return this.aliquotas?.percDvvFrete ?? 0;
    }

    /* Obtem o percentual da alíquota dos Royalties */
    getPercRoyalties(): number {
    	return this.itemCustos?.percRoyalties ?? 0;
    }

    /* Obtem se o cliente é isento de IPI */
    getIpiIsento(): boolean {
    	return this.aliquotas?.ipiIsento ?? false;
    }

    /* Obtem o percentual da alíquota do IPI */
    getPercAliquotaIpi(): number {
		// Alíquota fixa no estado do item
		if (this.itemCustos && (this.itemCustos.percAliquotaIpi != null && this.itemCustos.percAliquotaIpi !== undefined)) {
			return this.itemCustos.percAliquotaIpi;
		}
		// Alíquota atual
    	return this.aliquotas?.percAliquotaIpi ?? 0;
    }

    /* Obtem o custo variável unitário */
    getCustoVariavelUnitario(): number {
    	return this.itemCustos?.custoVariavel ?? 0;
    }

    /* Obtem o custo variável unitário */
    getCustoFixoUnitario(): number {
    	return this.itemCustos?.custoFixo ?? 0;
    }

    /* Obtem o percentual do Marketing */
    getPercMarketing(): number {
		// Override do item (inclusive 0) prevalece sobre a empresa
		if (this.itemCustos && (this.itemCustos.percDvvMarketing != null && this.itemCustos.percDvvMarketing !== undefined)) {
			return this.itemCustos.percDvvMarketing;
		}
    	return this.aliquotas?.percMarketing ?? 0;
    }

    /* Obtém o percentual das despesas administrativas */
    getPercDespesaAdministrativa(): number {
		// Override do item (inclusive 0) prevalece sobre a empresa
		if (this.itemCustos && (this.itemCustos.percDvvDespesaAdministrativa != null && this.itemCustos.percDvvDespesaAdministrativa !== undefined)) {
			return this.itemCustos.percDvvDespesaAdministrativa;
		}
    	return this.aliquotas?.percDespesaAdministrativa ?? 0;
    }

    /* Obtem o percentual das perdas e devoluções */
    getPercPerdaDevolucao(): number {
		// Override do item (inclusive 0) prevalece sobre a empresa
		if (this.itemCustos && (this.itemCustos.percDvvPerdaDevolucao != null && this.itemCustos.percDvvPerdaDevolucao !== undefined)) {
			return this.itemCustos.percDvvPerdaDevolucao;
		}
    	return this.aliquotas?.percPerdaDevolucao ?? 0;
    }

    /* Obtem o percentual de Outros */
    getPercOutros(): number {
		// Override do item (inclusive 0) prevalece sobre a empresa
		if (this.itemCustos && (this.itemCustos.percDvvOutros != null && this.itemCustos.percDvvOutros !== undefined)) {
			return this.itemCustos.percDvvOutros;
		}
    	return this.aliquotas?.percOutros ?? 0;
    }

    /* Obtem o percentual do custo financeiro */
    getPercCustoFinanceiro(): number {
    	return this.aliquotas?.percCustoFinanceiro ?? 0;
    }

    /* Obtem o percentual do desconto em contrato */
    getPercDescontoContrato(): number {
    	return this.aliquotas?.percDescontoContrato ?? 0;
    }

    /* Obtem o percentual da alíquota do IR */
    getPercIr(): number {
    	return this.aliquotas?.percIr ?? 0;
    }

    /* Obtem o percentual da alíquota do CSLL */
    getPercContribuicaoSocial(): number {
    	return this.aliquotas?.percContribuicaoSocial ?? 0;
    }

    /* Obtem o percentual minímo do lucro líquido */
    getPercLucroLiquidoMinimo(): number {
    	return this.aliquotas?.percLucroLiquidoMinimo ?? 0;
    }

    gerar(quantidade: number, valorTotalBruto: number, percComissao: number, nomeItem: string = '') {
        /*** 1. TOTAL BRUTO ***/
        this.valorTotalBruto = valorTotalBruto;

    	/** DVVs 1 = ICMS + PIS + COFINS + Frete + Perda e Devolução + Custo Financeiro + Desconto em Contrato **/
    	// ICMS
    	this.percAliquotaIcms = this.getPercAliquotaIcms();
    	this.calcularValorIcms();

    	// PIS
    	this.percAliquotaPis = this.getPercAliquotaPis();
		this.calcularBaseCalculoPis();
    	this.calcularValorPis();
    	this.calcularPercPisComposicao();

    	// COFINS
    	this.percAliquotaCofins = this.getPercAliquotaCofins();
		this.calcularBaseCalculoCofins();
    	this.calcularValorCofins();
    	this.calcularPercCofinsComposicao();

    	// Frete
    	this.percDvvFrete = this.getPercDvvFrete();
    	this.calcularValorDvvFrete();

    	// Perdas e Devoluções
    	this.percPerdaDevolucao = this.getPercPerdaDevolucao();
    	this.calcularValorPerdaDevolucao();

    	// Custo Financeiro
    	this.percCustoFinanceiro = this.getPercCustoFinanceiro();
    	this.calcularValorCustoFinanceiro();

    	// Desconto em Contrato
    	this.percDescontoContrato = this.getPercDescontoContrato();
    	this.calcularValorDescontoContrato();

    	// Total DVV's 1
    	this.somarValorDvvs1();
    	this.calcularPercDvvs1();

    	// Royalties
    	this.percRoyalties = this.getPercRoyalties();
    	this.calcularValorRoyalties();

    	// IPI
    	// Se for isento de IPI então não possui valor de IPI
    	this.ipiIsento = this.getIpiIsento();
    	if (!this.ipiIsento) {
    		this.percAliquotaIpi = this.getPercAliquotaIpi();
    		this.calcularValorIpi();
    	} else {
            this.percAliquotaIpi = null;
            this.valorIpi = null;
        }

    	// Comissão
    	this.percComissao = percComissao;
    	this.calcularValorComissao();

    	/*** 2. (-) DVV's (DVV's 1 + Royalties + IPI + Comissão) ***/
    	this.somarPercDvvs();
    	this.somarValorDvvs();
    	this.calcularPercDvvsComposicao();

    	/*** 3. (=) TOTAL LÍQUIDO ***/
    	this.calcularValorTotalLiquido();

    	/*** 4. CUSTO MATÉRIA PRIMA ***/
    	this.custoVariavelUnitario = this.getCustoVariavelUnitario();
    	this.calcularCustoVariavelTotal(quantidade);
    	this.calcularPercCustoVariavel();
    	this.calcularPercCustoVariavelComposicao();

    	/*** 5. (=) MARGEM DE CONTRIBUIÇÃO **/
    	this.calcularValorMargemContribuicao();
    	this.calcularPercMargemContribuicao();
    	this.calcularPercMargemContribuicaoComposicao();

    	/*** 5.1. (-) CUSTO DIRETO ***/
    	this.custoFixoUnitario = this.getCustoFixoUnitario();
    	this.calcularCustoFixoTotal(quantidade);
    	this.calcularPercCustoFixo();
    	this.calcularPercCustoFixoComposicao();

    	/** Custo Indireto = Marketing + ADM + Outros **/
    	// Marketing
    	this.percMarketing = this.getPercMarketing();
    	this.calcularValorMarketing();
    	this.calcularPercMarketingParticipacao();
    	// Despesas Administrativas
    	this.percDespesaAdministrativa = this.getPercDespesaAdministrativa();
    	this.calcularValorDespesaAdministrativa();
    	this.calcularPercDespesaAdministrativaParticipacao();
    	// Outros
    	this.percOutros = this.getPercOutros();
    	this.calcularValorOutros();
    	this.calcularPercOutrosParticipacao();

    	/*** 5.2. (-) CUSTO INDIRETO (Marketing + Despesas Administrativas + Outros) ***/
    	this.somarPercCustoIndireto();
    	this.somarValorCustoIndireto();
    	this.calcularPercCustoIndiretoParticipacao();
    	this.calcularPercCustoIndiretoComposicao();

    	/*** 6. (=) RESULTADO LÍQUIDO ***/
    	this.calcularValorResultadoLiquidoTotal();
    	this.calcularPercResultadoLiquidoTotal();
    	this.calcularPercResultadoLiquidoTotalComposicao();

    	/*** 7. (-) IR/CSLL ***/
    	// IR
    	this.percIr = this.getPercIr();
    	this.calcularValorIr();
    	this.calcularPercIrParticipacao();
    	// CSLL (Contribuição Social)
    	this.percContribuicaoSocial = this.getPercContribuicaoSocial();
    	this.calcularValorContribuicaoSocial();
    	this.calcularPercContribuicaoSocialParticipacao();
    	// IR (Imposto de Renda) + CSLL (Contribuição Social)
    	this.somarPercIrContribuicaoSocial();
    	this.somarValorIrContribuicaoSocial();
    	this.calcularPercIrContribuicaoSocialParticipacao();
    	this.calcularPercIrContribuicaoSocialComposicao();

    	/*** 8. (=) LUCRO LÍQUIDO ***/
    	this.calcularValorLucroLiquido();
    	this.calcularPercLucroLiquido();
    	this.calcularPercLucroLiquidoComposicao();
    	this.percLucroLiquidoMinimo = this.getPercLucroLiquidoMinimo();
    	this.percLucroLiquidoAbaixo = quantidade && (this.percLucroLiquido < this.percLucroLiquidoMinimo); // Quando o item possuir quantidade e o percentual de lucro líquido for menor que o mínimo definido

			/** Composições derivadas — dependem dos valores já apurados **/
			this.calcularComposicoesDerivadas();

			/*** 9. QUALIDADE DE VALOR (QV) ***/
			// Classificar o grupo de rentabilidade com base no lucro líquido calculado
			this.idGrupoRentabilidade = null;
			this.nomeGrupoRentabilidade = null;
			this.escalaGrupoRentabilidade = null;
			this.escalaSimboloGrupoRentabilidade = null;
			if (quantidade) {  // Somente classifica o grupo de rentabilidade se o item possuir quantidade, caso contrário atribuímos o grupo de rentabilidade padrão do item (se existir) ou deixamos nulo (sem grupo de rentabilidade)
				const grupoRentabilidade = getGrupoRentabilidadeByMargem(this.gruposRentabilidade ?? [], this.percLucroLiquido);
				if (grupoRentabilidade) { // Grupo de rentabilidade encontrado para a margem de lucro líquido calculada
					this.idGrupoRentabilidade = grupoRentabilidade.id;
					this.nomeGrupoRentabilidade = grupoRentabilidade.nome;
					this.escalaGrupoRentabilidade = grupoRentabilidade.escala;
					this.escalaSimboloGrupoRentabilidade = grupoRentabilidade.escalaSimbolo;
				}
			} else if (this.grupoRentabilidadePadrao) { // Se não possuir quantidade então atribuímos o grupo de rentabilidade padrão do item (se existir)
				this.idGrupoRentabilidade = this.grupoRentabilidadePadrao.id;
				this.nomeGrupoRentabilidade = this.grupoRentabilidadePadrao.nome;
				this.escalaGrupoRentabilidade = this.grupoRentabilidadePadrao.escala;
				this.escalaSimboloGrupoRentabilidade = this.grupoRentabilidadePadrao.escalaSimbolo;
			}
    }
}
